import React, { useState, useContext } from 'react'
import ContextMenu from './ContextMenu'
import { ListItemIcon, ListItemText, MenuItem, MenuList, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { CopyInboundTemplate, DeleteInboundTemplate, LocalRevisionHistory, NewWorkflowGroup, ReloadInboundTemplate, RenameSelectedTemplate, DeployToServer } from './WorkflowGroupActions';
import NewWorkflowWizard from './WorkflowGroupActions/NewWorkflowWizard';
import ServerRevisionHistory from './WorkflowGroupActions/ServerRevisionHistory';
import DownloadTemplate from './WorkflowGroupActions/DownloadTemplate';
import UploadTemplate from './WorkflowGroupActions/UploadTemplate';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

function WorkflowTemplateMenu({ targetId }) {
  const { t } = useTranslation();
  const [templateOption, setTemplateOption] = useState(null)
  const parentScreen = useContext(ParentScreenCtx);
  const { leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = leftTree.tree.body.selectedNode;
  
  const handleWorkflowTemplateModal = (option) => {
    setTemplateOption(option)
  }  
  return (
    <>
      <ContextMenu targetId={targetId}>
        <Paper sx={{ minWidth: "17rem" }}>
          <MenuList dense>
            <MenuItem
              name={t("MNU_NEW_WF_GROUP")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_NEW_WF_GROUP"))}>
              <ListItemIcon>
                <span className="RECORD"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_NEW_WF_GROUP")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_NEW_WF_WIZ")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_NEW_WF_WIZ"))}>
              <ListItemIcon>
                <span className="WIZARD"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_NEW_WF_WIZ")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_COPY_WF_TIT")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_COPY_WF_TIT"))}>
              <ListItemIcon>
                <span className="COPY"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_COPY_WF_TIT")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_RENAME_WF_TIT")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_RENAME_WF_TIT"))}>
              <ListItemIcon>
                <span className="RENAME_WORKFLOW"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_RENAME_WF_TIT")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_DELETE_WF_TIT")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_DELETE_WF_TIT"))}>
              <ListItemIcon>
                <span className="DELETE_WORKFLOW"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_DELETE_WF_TIT")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_RELOAD_WF")}
              onClick={() => handleWorkflowTemplateModal(t("MNU_RELOAD_WF"))}>
              <ListItemIcon>
                <span className="RELOAD_WORKFLOW"></span>
              </ListItemIcon>
              <ListItemText>{t("MNU_RELOAD_WF")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("LBL_LOCAL_USER_REVISION_HISTORY")}
              onClick={() => handleWorkflowTemplateModal(
                t("LBL_LOCAL_USER_REVISION_HISTORY")
              )}>
              <ListItemIcon>
                <span className={"REVISION_HISTORY"}></span>
              </ListItemIcon>
              <ListItemText>
                {t("LBL_LOCAL_USER_REVISION_HISTORY")}
              </ListItemText>
            </MenuItem>
            <MenuItem
              name={t("LBL_SERVER_REV")}
              onClick={() => handleWorkflowTemplateModal(t("LBL_SERVER_REV"))}>
              <ListItemIcon>
                <span className={"REVISION_HISTORY"}></span>
              </ListItemIcon>
              <ListItemText>{t("LBL_SERVER_REV")}</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleWorkflowTemplateModal(t("LBL_UPLOAD_TEMP"))
              }>
              <ListItemIcon>
                <span className="UPLOAD_TEMPLATE"></span>
              </ListItemIcon>
              <ListItemText>{t("LBL_UPLOAD_TEMP")}</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleWorkflowTemplateModal(t("LBL_DOWNLOAD_TEMP"))
              }>
              <ListItemIcon>
                <span className="DOWNLOAD_TEMPLATE"></span>
              </ListItemIcon>
              <ListItemText>{t("LBL_DOWNLOAD_TEMP")}</ListItemText>
            </MenuItem>
            {/* Deploy to Server - Show for userspace-only files and files that exist in both locations */}
            {(selectedNode?.location === 'userspace' || selectedNode?.location === 'both') && (
              <MenuItem
                name={t("DEPLOY_TO_SERVER")}
                onClick={() => handleWorkflowTemplateModal(t("DEPLOY_TO_SERVER"))}>
                <ListItemIcon>
                  <span className="SERVER"></span>
                </ListItemIcon>
                <ListItemText>{t("DEPLOY_TO_SERVER")}</ListItemText>
              </MenuItem>
            )}
          </MenuList>
        </Paper>
      </ContextMenu>
      <NewWorkflowGroup
        modalOpen={templateOption === t("MNU_NEW_WF_GROUP")}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
      <NewWorkflowWizard 
        modalOpen={templateOption === t('MNU_NEW_WF_WIZ')}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
      <RenameSelectedTemplate
        openModal={templateOption === t('MNU_RENAME_WF_TIT')}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
      <DeleteInboundTemplate
        openModal={templateOption === t('MNU_DELETE_WF_TIT')}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
      <CopyInboundTemplate
        openModal={templateOption === t('MNU_COPY_WF_TIT')}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
      <ReloadInboundTemplate
       openModal={templateOption === t('MNU_RELOAD_WF')}
       toggle={() => handleWorkflowTemplateModal(null)}
      />
      <ServerRevisionHistory
       openModal={templateOption === t('LBL_SERVER_REV')}
       toggle={() => handleWorkflowTemplateModal(null)}
      />
      <LocalRevisionHistory
       openModal={templateOption === t('LBL_LOCAL_USER_REVISION_HISTORY')}
       toggle={() => handleWorkflowTemplateModal(null)}
      />
      {templateOption === t("LBL_DOWNLOAD_TEMP") && (
        <DownloadTemplate
          open={templateOption === t("LBL_DOWNLOAD_TEMP")}
          toggle={() => handleWorkflowTemplateModal(null)}
        />
      )}
      {templateOption === t("LBL_UPLOAD_TEMP") && (
        <UploadTemplate open={templateOption === t('LBL_UPLOAD_TEMP')} toggle={() => handleWorkflowTemplateModal(null)} />
      )}
      <DeployToServer
        open={templateOption === t("DEPLOY_TO_SERVER")}
        toggle={() => handleWorkflowTemplateModal(null)}
      />
    </>
  );
}

export default WorkflowTemplateMenu